(function() {
    angular.module('emarket.commons').factory('AuthInterceptor', ['$log', '$location', '$q', function($log, $location, $q) {
        return {
            responseError: function(config) {
                if(config.status === 401) {
                    $location.path('inicio-de-sesion');
                }
                return $q.reject(config);
            }
        };
    }]);
}());
